import $i18n from 'panda-i18n';
import React, { useCallback, useContext, useMemo } from 'react';
import { CnIcon } from '@/components/cn-icon';
import { CnLoading } from '@/components/cn-loading';
import { UploadStateContext } from '@/components/upload-core/context';
import { useShowRemove } from '@/components/upload-core/hooks/use-show-remove';
import { useShowPreview } from '@/components/upload-core/hooks/use-show-preview';
import { CnImageViewer } from '@/components/cn-image-viewer';
import { useOnRemove } from '@/components/upload-core/hooks/use-on-remove';
export const UploadListItem = (props) => {
    const { value, readOnly, onPreview: _onPreview, getFileFromCache, } = useContext(UploadStateContext);
    const onRemove = useOnRemove();
    const { index, style } = props;
    const file = getFileFromCache(props.file);
    const { status } = file;
    const isUploading = status && ['idle', 'uploading'].includes(status);
    const showRemove = useShowRemove(file);
    const showPreview = useShowPreview(file);
    const url = useMemo(() => file.objectUrl || file.url, [file]);
    const showError = !readOnly && status === 'error';
    const onPreview = useCallback((_file) => {
        if (_onPreview) {
            _onPreview(_file);
            return;
        }
        CnImageViewer.open({
            index,
            src: value.map((_item) => {
                const item = getFileFromCache(_item);
                return item.objectUrl || item.url;
            }),
        });
    }, [_onPreview, index, value, getFileFromCache]);
    return (React.createElement("div", { style: style, className: "cn-ui-m-oss-image-upload-item" },
        showError ? (React.createElement("div", { className: "cn-ui-m-oss-image-upload-item-error" },
            React.createElement(CnIcon, { type: "exclamation-r", size: "large" }),
            React.createElement("span", { className: "cn-ui-m-oss-image-upload-item-error-text" }, file.errorMsg ||
                $i18n.get({
                    id: 'UploadFailed',
                    dm: '上传失败',
                    ns: 'CnOssUpload',
                })))) : null,
        !showError && isUploading ? (React.createElement("div", { className: "cn-ui-m-oss-image-upload-item-uploading" },
            React.createElement(CnLoading, { visible: true, inverse: true }))) : null,
        showRemove ? (React.createElement("div", { className: "cn-ui-m-oss-image-upload-item-remove", onClick: () => onRemove(file) },
            React.createElement("div", { className: "cn-ui-m-oss-image-upload-item-remove-inner" },
                React.createElement(CnIcon, { type: "error", size: "xs" })))) : null,
        React.createElement("div", { style: { backgroundImage: `url(${url})` }, className: "cn-ui-m-oss-image-upload-item-img", onClick: () => {
                if (!showPreview)
                    return;
                onPreview(file);
            } })));
};
